module.exports = __webpack_public_path__ + "img/bg01.a82dd912.jpg";